/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";

/**
 * GLOBAL STATE (singleton)
 */
let assetsLoaded = false;
let eventsBound = false;
let activeHandler = null;

/**
 * LOAD ADDRESSNOW ASSETS (only once)
 */
const loadAssets = (apiKey) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || assetsLoaded) {
      resolve();
        ;
    }

    if (!apiKey) {
      console.warn("AddressNow API key missing");
      resolve();
      return;
    }

    if (window.addressNow) {
      assetsLoaded = true;
      resolve();
      return;
    }

    // CSS
    if (!document.getElementById("addressnow-css")) {
      const link = document.createElement("link");
      link.id = "addressnow-css";
      link.rel = "stylesheet";
      link.href =
        "//api.addressnow.co.uk/css/addressnow-2.20.min.css?key=" + apiKey;
      document.head.appendChild(link);
      console.log("link", link)
    }

    // JS
    if (!document.getElementById("addressnow-js")) {
      const script = document.createElement("script");
      script.id = "addressnow-js";
      script.src =
        "//api.addressnow.co.uk/js/addressnow-2.20.min.js?key=" + apiKey;
      script.async = true;

      script.onload = () => {
        assetsLoaded = true;
        resolve();
      };

      script.onerror = resolve;
      document.body.appendChild(script);
      console.log("script", script)
    } else {
      assetsLoaded = true;
      resolve();
    }
  });
};

/**
 * BIND EVENTS (only once)
 */
const bindEvents = () => {
  if (!window.addressNow || eventsBound) return;

  eventsBound = true;

  window.addressNow.listen("load", (control) => {
    control.listen("populate", (address) => {
      if (!activeHandler) return;

      const parsed = {
        address_1:
          address?.Line1 ||
          address?.FormattedLine1 ||
          address?.SubBuilding ||
          "",
        address_2: address?.Line2 || "",
        address_3: address?.Line3 || "",
        town: address?.City || address?.AdminAreaName || "",
        county: address?.Province || address?.AdminAreaName || "",
        country: address?.CountryName || "",
        postcode: address?.PostalCode || "",
      };

      activeHandler(parsed);
    });
  });
};

/**
 * COMPONENT
 */
const AddressSearchField = (props) => {
  const {
    apiKey,
    value,
    onChange,
    onSelect
  } = props;

  // IMPORTANT: AddressNow requires a fixed ID
  const [inputId] = useState(() => "address-search-" + Math.floor(Math.random() * 1000000));
  const [inputName, setInputName] = useState('postcode-search');

  useEffect(() => {
    const handleFocusEvent = (e) => {
      if (e.detail !== inputId) {
        setInputName(`postcode-search-inactive-${inputId}`);
      }
    };
    
    window.addEventListener('addressSearchFocus', handleFocusEvent);
    return () => {
      window.removeEventListener('addressSearchFocus', handleFocusEvent);
    };
  }, [inputId]);

  const activate = async () => {
    setInputName('postcode-search');
    window.dispatchEvent(new CustomEvent('addressSearchFocus', { detail: inputId }));

    if (!apiKey) return;

    await loadAssets(apiKey);
    bindEvents();

    activeHandler = (data) => {
      if (onSelect) onSelect(data);
    };

    if (window.addressNow && window.addressNow.load) {
      window.addressNow.load();
    }
  };

  useEffect(() => {
    // If already active or script exists, attempt to load once
    if (window.addressNow && window.addressNow.load) {
      window.addressNow.load();
    }

    return () => {
      activeHandler = null;
    };
  }, []);

  return (
    <div className="address-search-wrapper">
      {/* SEARCH INPUT */}
      <div>
        <input
          type="text"
          id={inputId}
          name={inputName}
          data-addressnow="search"
          value={value || ""}
          placeholder="Enter postcode"
          className="form-control"
          onFocus={activate}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default AddressSearchField;